import type { ReactNode } from "react";

interface SplitFieldProps {
  leading: ReactNode;
  children: ReactNode;
}

/** A compact leading field paired with a wider value field. */
export function SplitField({ children, leading }: SplitFieldProps): ReactNode {
  return (
    <fieldset className="grid grid-cols-3 gap-space-sm">
      <div>{leading}</div>
      <div className="col-span-2">{children}</div>
    </fieldset>
  );
}
